export default class PaginationData {
  constructor(pagination = {}) {
    this.page = pagination.page ? parseInt(pagination.page) : 0
    this.limit = pagination.maxRows ? parseInt(pagination.maxRows) : 50
    this.total = parseInt(pagination.total)

    this.from = (this.page * this.limit) + 1
    this.to = calcTo(this.page, this.limit, this.total)
    this.lastPage = (Math.floor(this.total / this.limit) + ((this.total % this.limit) === 0 ? 0 : 1)) - 1

    this.getRange = this.getRange.bind(this)
    this.hasPrevious = this.hasPrevious.bind(this)
  }

  getRange(count) {
    var minFrom = 0
    var maxTo = this.lastPage

    var from = this.page - (count - 1) / 2
    var to = this.page + (count - 1) / 2

    if (from < minFrom) {
      to += minFrom - from
    }
    if (to > maxTo) {
      from += maxTo - to
    }

    from = from < minFrom ? minFrom : from
    to = to > maxTo ? maxTo : to

    var range = []
    for (var i = from; i <= to; i++) {
      range.push(i)
    }
    return range
  }

  hasPrevious() {
    return this.from !== 1
  }

  hasNext() {
    return this.to < this.total
  }
}

export function calcTo(page, limit, total) {
  return total < limit
    ? total
    : page * limit + (total < ((page + 1) * limit) ? (total % limit) : limit)
}



// WEBPACK FOOTER //
// ./src/pages/pagination/PaginationData.js